import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from 'redux/store';
import { PermissionsState } from '../../@types/permissions';
import { translator } from 'translation/useTranslator';

const initialState: PermissionsState = {
  isLoading: false,
  assignableRoles: []
};

const slice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    getPermissionsSuccess(state, action) {
      const { assignableRoles } = action.payload;
      state.isLoading = false;
      state.assignableRoles = assignableRoles as string[];
    }
  }
});

// Reducer
export default slice.reducer;

export const getPermissions = () => {
  return async () => {
    dispatch(
      slice.actions.getPermissionsSuccess({
        assignableRoles: ['CompanyAdmin', 'CompanyUser']
      })
    );
    return {
      defaultSuccessMessage: translator?.userPermissionsFetched() ?? 'User permissions fetched'
    };
  };
};
